import { Star } from "lucide-react";
import Reveal from "./Reveal";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { REVIEWS } from "@/config/clinicConfig";

function Stars() {
  return (
    <div className="flex gap-0.5" aria-label="5 out of 5 stars">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} size={16} className="text-gold" fill="currentColor" strokeWidth={0} />
      ))}
    </div>
  );
}

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-6xl px-5 lg:px-8">
        <Reveal className="text-center">
          <h2 className="font-display text-3xl font-medium tracking-tight text-espresso sm:text-4xl lg:text-[2.75rem]">
            {REVIEWS.heading}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-cocoa">{REVIEWS.sub}</p>
        </Reveal>

        <Reveal delay={0.1}>
          <Carousel data-testid="reviews-carousel" className="mt-12" opts={{ align: "start", loop: true }}>
            <CarouselContent>
              {REVIEWS.items.map((r) => (
                <CarouselItem key={r.id} className="basis-full sm:basis-1/2 lg:basis-1/3">
                  <div
                    data-testid={`review-slide-${r.id}`}
                    className="flex h-full flex-col rounded-3xl border border-espresso/10 bg-cream p-7 shadow-[0_20px_50px_-30px_rgba(44,34,30,0.35)] transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5"
                  >
                    <div className="flex items-center justify-between">
                      <Stars />
                      <span className="rounded-full border border-espresso/15 px-2.5 py-0.5 font-mono text-[9px] uppercase tracking-[0.16em] text-cocoa/70">
                        Google review
                      </span>
                    </div>
                    <p className="mt-5 flex-1 text-sm leading-relaxed text-cocoa sm:text-[15px]">{r.text}</p>
                    <div className="mt-6 border-t border-espresso/10 pt-4">
                      <p className="font-display text-base font-semibold tracking-tight text-espresso">{r.name}</p>
                      <p className="mt-0.5 font-mono text-[10px] uppercase tracking-[0.16em] text-clay">{r.meta}</p>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious
              data-testid="reviews-prev-button"
              className="-left-3 h-10 w-10 rounded-full border-espresso/15 bg-cream text-espresso hover:bg-clay hover:text-cream lg:-left-5"
            />
            <CarouselNext
              data-testid="reviews-next-button"
              className="-right-3 h-10 w-10 rounded-full border-espresso/15 bg-cream text-espresso hover:bg-clay hover:text-cream lg:-right-5"
            />
          </Carousel>
        </Reveal>
      </div>
    </section>
  );
}
